export default "https://assets.egbcdn.net/assets/packs/_/images/promo_action/instructions/image6-dcb4f2dc5633ba55c3bf54fa91679ba5.png";